// Delays of the upload pipeline (GED-FE-02). A module-level object so tests can shorten them
// (`Object.assign(uploadTiming, { retryDelays: [0, 1] })`); nothing else changes them.

export interface UploadTiming {
  /** Waits between two attempts of a failed part (or completion): ~70 s of retries in all. */
  retryDelays: number[];
  /** Between two reads of the upload status while the file is being checked. */
  pollIntervalMs: number;
  /** After this long the message says the check is slower than usual and the polling slows down. */
  slowAfterMs: number;
  slowPollIntervalMs: number;
  /** The polling stops after this long (the file still appears in the folder when checked). */
  giveUpAfterMs: number;
  /** A part URL is refreshed when it expires in less than this. */
  urlMarginMs: number;
}

export const DEFAULT_UPLOAD_TIMING: Readonly<UploadTiming> = {
  retryDelays: [0, 1000, 3000, 5000, 10_000, 20_000, 30_000],
  pollIntervalMs: 2000,
  slowAfterMs: 2 * 60_000,
  slowPollIntervalMs: 10_000,
  giveUpAfterMs: 30 * 60_000,
  urlMarginMs: 30_000,
};

export const uploadTiming: UploadTiming = {
  ...DEFAULT_UPLOAD_TIMING,
  retryDelays: [...DEFAULT_UPLOAD_TIMING.retryDelays],
};
